document.addEventListener('DOMContentLoaded', function() {

  window.iso_options = {
    itemSelector : '.item',
    layoutMode : 'packery'
  }


  // ---------------------------------------------------------- MOBILE HOVER
  // ----------------------------------------------------------

  // Classe al body per la gestione dell'hover in mobile
  const canHover = !(matchMedia('(hover: none)').matches);
  if(!canHover) {
    document.body.classList.add('mobile-hover');

    document.querySelectorAll('article.item a.tile').forEach(function(tile) {
      tile.addEventListener('click', function(e) {
        if(this.classList.contains('attiva')){
          // proceed with default
        } else {
          e.preventDefault();
          document.querySelectorAll('article.item a.tile').forEach(function(t) {
            t.classList.remove('attiva');
          });
          this.classList.add('attiva');
        }
      });
    });
  }


  // ---------------------------------------------------------- URBANPROMO HOME
  // ----------------------------------------------------------

  // Carousel Grid — horizontal paginated tile grid (any page)
  document.querySelectorAll('[comp="carousel-grid"]').forEach(function(el) {
    new CarouselGrid(el);
  });


  // ---------------------------------------------------------- URBANPROMO ARCHIVIO EDIZIONI
  // ----------------------------------------------------------
  if( document.body.classList.contains('page-template-template-archivio-edizioni') || document.body.classList.contains('page-template-template-gallery') ){

    /* ---------------------------------------------------------
    Module: Archivio Edizioni — new filtri-livello1 + filtri-pannello
    --------------------------------------------------------- */
    ArchivioEdizioni.init();

  }


  // ---------------------------------------------------------- ALL PAGES
  // ----------------------------------------------------------

  // Project toggle redirect
  if (!document.body.classList.contains('home')){
    const projectsToggle = document.querySelector('.projects-toggle a');

    if(projectsToggle){
      const currentDomain = window.location.origin;
      const redirectURL = `${currentDomain}/info/?gallery=open`;
      projectsToggle.setAttribute('href', redirectURL);
    }
  }



  // ---------------------------------------------------------- URBANPROMO CONCORSI
  // ----------------------------------------------------------
  if( document.body.classList.contains('single-concorsi') ){

    /* ---------------------------------------------------------
    Module: Mostra Progetti dell'edizione richiesta
    --------------------------------------------------------- */
    UbpHome.homeScripts();
    FiltriContenuto.start();

  }


  // ---------------------------------------------------------- URBANPROMO EVENTI
  // ----------------------------------------------------------
  if( document.body.classList.contains('tax-sede-evento') ||
      document.body.classList.contains('post-type-archive-eventi')
    ){

    /* ---------------------------------------------------------
    Module: Toggle Barre dei filtri progetti / eventi
    --------------------------------------------------------- */
    UbpEventi.toggleFiltriHeader();

    /* ---------------------------------------------------------
    Module: Filtri e init isotope della pagina eventi
    --------------------------------------------------------- */
    UbpEventi.eventiScripts();

    /* ---------------------------------------------------------
    Module: Archivio eventi redesign (filtri tipo-evento, giorno, sala)
    --------------------------------------------------------- */
    UbpEventi.archivioEventi();

  }


  // ---------------------------------------------------------- BOOTSTRAP
  // ----------------------------------------------------------

  // Abilita i tooltip
  document.querySelectorAll('[data-bs-toggle="tooltip"], [data-toggle="tooltip"]').forEach(function(el) {
    if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
      new bootstrap.Tooltip(el);
    }
  });


  // ---------------------------------------------------------- UBP NAVBAR
  // ----------------------------------------------------------

  // --- Disable Bootstrap native dropdowns on network header (we use custom accordion/drill-down) ---
  document.querySelectorAll('#network-header .dropdown-toggle[data-bs-toggle], #network-header-mobile .dropdown-toggle[data-bs-toggle]').forEach(function(el) {
    if (typeof bootstrap !== 'undefined' && bootstrap.Dropdown) {
      var instance = bootstrap.Dropdown.getInstance(el);
      if (instance) { instance.dispose(); }
    }
    el.removeAttribute('data-bs-toggle');
  });

  // --- Desktop submenu accordion ---
  var networkHeader = document.getElementById('network-header');

  // Helper: update glass extend to cover open dropdown
  function updateGlassExtend() {
    if (!networkHeader) { return; }
    var openDropdown = networkHeader.querySelector('.ubp-navbar-menu > li > ul.dropdown-menu.show');
    if (!openDropdown) {
      networkHeader.style.setProperty('--glass-extend', '0px');
      return;
    }
    // Use requestAnimationFrame for accurate measurement after DOM update
    requestAnimationFrame(function() {
      var headerRect = networkHeader.getBoundingClientRect();
      var dropdownRect = openDropdown.getBoundingClientRect();
      var extend = Math.max(0, dropdownRect.bottom - headerRect.bottom);
      networkHeader.style.setProperty('--glass-extend', extend + 'px');
    });
  }

  document.querySelectorAll('#network-header .ubp-navbar-menu > li.dropdown').forEach(function(item) {
    var toggle = item.querySelector(':scope > a.dropdown-toggle');
    if (!toggle) { return; }

    // Custom accordion (Bootstrap dropdown disabled above)
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var dropdown = item.querySelector(':scope > ul.dropdown-menu');
      if (!dropdown) { return; }
      // Close other open dropdowns first
      document.querySelectorAll('#network-header .dropdown-menu.show').forEach(function(d) {
        if (d !== dropdown) { d.classList.remove('show'); }
      });
      dropdown.classList.toggle('show');
      updateGlassExtend();
    });

    // Sub-level accordion within dropdown — add arrow icons for items with children
    item.querySelectorAll('ul.dropdown-menu > li.dropdown > a').forEach(function(subToggle) {
      // Add arrow icon (Figma 1606:38807)
      var arrow = document.createElement('span');
      arrow.className = 'material-symbols-outlined ubp-submenu-arrow';
      arrow.textContent = 'keyboard_arrow_down';
      subToggle.appendChild(arrow);

      subToggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var subMenu = this.nextElementSibling;
        if (subMenu && subMenu.classList.contains('dropdown-menu')) {
          // Toggle expanded style on the link
          var isExpanded = this.classList.toggle('--expanded');
          subMenu.classList.toggle('show');
          // Update arrow icon
          arrow.textContent = isExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
          // Update glass height (sub-menu changes dropdown size)
          updateGlassExtend();
        }
      });
    });
  });

  // Close desktop dropdowns on click outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('#network-header')) {
      document.querySelectorAll('#network-header .dropdown-menu.show').forEach(function(d) {
        d.classList.remove('show');
      });
      // Also reset expanded arrows
      document.querySelectorAll('#network-header .--expanded').forEach(function(el) {
        el.classList.remove('--expanded');
        var arr = el.querySelector('.ubp-submenu-arrow');
        if (arr) { arr.textContent = 'keyboard_arrow_down'; }
      });
      updateGlassExtend();
    }
  });

  // --- Mobile: hamburger icon toggle (reorder ↔ close) ---
  var mobileCollapse = document.getElementById('ubpMobileMenu');
  if (mobileCollapse) {
    mobileCollapse.addEventListener('show.bs.collapse', function() {
      var icon = document.querySelector('#ubpMobileToggler .material-symbols-outlined');
      if (icon) { icon.textContent = 'close'; }
    });
    mobileCollapse.addEventListener('hide.bs.collapse', function() {
      var icon = document.querySelector('#ubpMobileToggler .material-symbols-outlined');
      if (icon) { icon.textContent = 'reorder'; }
    });
  }

  // --- Mobile: drill-down navigation ---
  (function() {
    var collapseEl = document.getElementById('ubpMobileMenu');
    if (!collapseEl) { return; }

    var menuEl = collapseEl.querySelector('.ubp-mobile-menu');
    if (!menuEl) { return; }

    // Find all top-level items with dropdown children
    var itemsWithChildren = menuEl.querySelectorAll(':scope > li.dropdown');
    if (!itemsWithChildren.length) { return; }

    // Create panels container
    var panelsContainer = document.createElement('div');
    panelsContainer.className = 'ubp-mobile-panels';

    // Wrap the main menu list as panel-0
    var mainPanel = document.createElement('div');
    mainPanel.className = 'ubp-mobile-panel --active';
    mainPanel.setAttribute('data-panel', '0');

    // Move menu into the main panel
    menuEl.parentNode.insertBefore(panelsContainer, menuEl);
    mainPanel.appendChild(menuEl);
    panelsContainer.appendChild(mainPanel);

    // For each item with children, create a sub-panel
    var panelIndex = 0;
    itemsWithChildren.forEach(function(li) {
      panelIndex++;
      var subMenu = li.querySelector(':scope > ul.dropdown-menu');
      if (!subMenu) { return; }

      // Create sub-panel
      var subPanel = document.createElement('div');
      subPanel.className = 'ubp-mobile-panel --right';
      subPanel.setAttribute('data-panel', String(panelIndex));

      // Back button
      var backBtn = document.createElement('button');
      backBtn.className = 'ubp-mobile-back';
      backBtn.type = 'button';
      backBtn.innerHTML = '<span class="material-symbols-outlined">arrow_back</span> Indietro';
      subPanel.appendChild(backBtn);

      // Move the dropdown-menu into sub-panel and reclassify
      subMenu.style.removeProperty('display');
      subMenu.classList.remove('dropdown-menu');
      subMenu.classList.add('ubp-submenu-list');
      // Strip dropdown-menu from inner sub-levels (prevents Bootstrap overrides)
      subMenu.querySelectorAll('ul.dropdown-menu').forEach(function(innerUl) {
        innerUl.classList.remove('dropdown-menu');
      });
      // Force display flex (remove !important from CSS hiding)
      subMenu.style.display = 'flex';
      subMenu.style.flexDirection = 'column';
      subMenu.style.gap = '4px';
      subMenu.style.listStyle = 'none';
      subMenu.style.padding = '0';
      subMenu.style.margin = '0';
      subPanel.appendChild(subMenu);

      panelsContainer.appendChild(subPanel);

      // Store panel reference on the li
      li.setAttribute('data-target-panel', String(panelIndex));

      // Click handler on parent item to open sub-panel
      var parentLink = li.querySelector(':scope > a');
      if (parentLink) {
        parentLink.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          navigateToPanel(panelsContainer, mainPanel, subPanel);
        });
      }

      // Back button handler
      backBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        navigateToPanel(panelsContainer, subPanel, mainPanel);
      });

      // Sub-sub items: accordion toggle (level 2 dropdowns within sub-panel)
      subMenu.querySelectorAll(':scope > li.dropdown > a').forEach(function(subToggle) {
        // Add arrow icon (same as desktop — Figma 1638:8819)
        var arrow = document.createElement('span');
        arrow.className = 'material-symbols-outlined ubp-submenu-arrow';
        arrow.textContent = 'keyboard_arrow_down';
        subToggle.appendChild(arrow);

        subToggle.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var subSubMenu = this.nextElementSibling;
          if (subSubMenu) {
            var isExpanded = this.classList.toggle('--expanded');
            subSubMenu.classList.toggle('show');
            // Toggle arrow direction
            arrow.textContent = isExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
            // Update panel height
            updatePanelHeight(panelsContainer, subPanel);
          }
        });
      });
    });

    // Set initial height
    updatePanelHeight(panelsContainer, mainPanel);

    // Re-calculate height when collapse opens
    if (mobileCollapse) {
      mobileCollapse.addEventListener('shown.bs.collapse', function() {
        var activePanel = panelsContainer.querySelector('.ubp-mobile-panel.--active');
        if (activePanel) {
          updatePanelHeight(panelsContainer, activePanel);
        }
      });
    }

    function navigateToPanel(container, fromPanel, toPanel) {
      // Determine direction
      var fromIdx = parseInt(fromPanel.getAttribute('data-panel') || '0', 10);
      var toIdx = parseInt(toPanel.getAttribute('data-panel') || '0', 10);
      var goingDeeper = toIdx > fromIdx;

      // Animate out
      fromPanel.classList.remove('--active');
      fromPanel.classList.add(goingDeeper ? '--left' : '--right');

      // Animate in
      toPanel.classList.remove('--left', '--right');
      toPanel.classList.add('--active');

      // Update container height
      updatePanelHeight(container, toPanel);
    }

    function updatePanelHeight(container, activePanel) {
      // Use requestAnimationFrame to get the correct height after DOM update
      requestAnimationFrame(function() {
        container.style.height = activePanel.scrollHeight + 'px';
      });
    }
  })();


  // ---------------------------------------------------------- FANCYBOX
  // ----------------------------------------------------------

  if (typeof Fancybox !== 'undefined') {
    // Fancybox 5+ (vanilla JS — @fancyapps/ui)
    Fancybox.bind('.fancybox', {});
    Fancybox.bind('[data-fancybox]', {});
  } else if (typeof jQuery !== 'undefined' && jQuery.fn.fancybox) {
    // Fancybox 3 (jQuery — @fancyapps/fancybox, current vendor build)
    jQuery(".fancybox").fancybox({ prevEffect: 'none', nextEffect: 'none' });
    jQuery.fancybox.defaults.loop = true;
  }


  // ---------------------------------------------------------- SWIPER CON NAV-THUMB + FANCYBOX
  // ----------------------------------------------------------

  document.querySelectorAll('.slider-main').forEach(function (el) {
    var blocco = el.closest('.blocco-galleria');
    var ordinamento = blocco ? blocco.dataset.row : '';

    // Parse slide titles for nav title updates
    var slideTitles = [];
    if (blocco && blocco.dataset.slideTitles) {
      try { slideTitles = JSON.parse(blocco.dataset.slideTitles); } catch(e) {}
    }

    // Update nav titles in the active slide on slide change
    function updateNavTitles(swiper) {
      if (!slideTitles.length) return;
      var realIndex = swiper.realIndex;
      var totalSlides = slideTitles.length;
      var prevIndex = (realIndex - 1 + totalSlides) % totalSlides;
      var nextIndex = (realIndex + 1) % totalSlides;

      // Update title elements in the currently visible slide
      var activeSlide = swiper.slides[swiper.activeIndex];
      if (activeSlide) {
        var prevTitle = activeSlide.querySelector('.ubp-slideshow-nav-title-prev');
        var nextTitle = activeSlide.querySelector('.ubp-slideshow-nav-title-next');
        if (prevTitle) prevTitle.textContent = slideTitles[prevIndex];
        if (nextTitle) nextTitle.textContent = slideTitles[nextIndex];
      }
    }

    var galleryTop = new Swiper(el, {
      spaceBetween: 10,
      loop: true,
      loopedSlides: 6,
      autoHeight: true,
      autoplay: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      lazy: {
        loadPrevNext: true,
      },
      navigation: {
        nextEl: '.swiper-next.row-' + ordinamento,
        prevEl: '.swiper-prev.row-' + ordinamento,
      },
      on: {
        init: function () { updateNavTitles(this); },
        slideChange: function () { updateNavTitles(this); }
      }
    });

    var thumbEl = document.querySelector('.slider-thumb.row-' + ordinamento);
    if (thumbEl) {
      var galleryThumbs = new Swiper(thumbEl, {
        spaceBetween: 16,
        slidesPerView: 'auto',
        centeredSlides: true,
        slideToClickedSlide: true,
        lazy: {
          loadPrevNext: true,
        },
        loop: true,
        loopedSlides: 6,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      });

      if (el.classList.contains('thumbson')) {
        galleryTop.controller.control = galleryThumbs;
        galleryThumbs.controller.control = galleryTop;
      }
    }
  });


  // ---------------------------------------------------------- LAZYLOAD
  // ----------------------------------------------------------
  const observer = lozad('.lozad', {
    loaded: function(el) {
    }
  });
  observer.observe();


  // ---------------------------------------------------------- ISCRIZIONE NEWSLETTER
  // ----------------------------------------------------------

  document.body.addEventListener('click', function(e) {
    if (e.target.closest('#main-newsletter-modal')) {
      var modal = document.getElementById('newsletter-modal');
      if (modal && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
        var bsModal = bootstrap.Modal.getOrCreateInstance(modal);
        bsModal.show();
      }
    }
  });

  // Copy footer email input into CF7 modal field on modal open
  var newsletterModal = document.getElementById('newsletter-modal');
  if (newsletterModal) {
    newsletterModal.addEventListener('show.bs.modal', function () {
      var footerInput = document.querySelector('.ubp-newsletter-input');
      var cf7Email = newsletterModal.querySelector('input[name="your-email"]');
      if (footerInput && cf7Email && footerInput.value) {
        cf7Email.value = footerInput.value;
      }
    });

    // Auto-open modal if arriving with ?newsletter= param (redirect from other sites)
    var urlParams = new URLSearchParams(window.location.search);
    var nlEmail = urlParams.get('newsletter');
    if (nlEmail) {
      setTimeout(function () {
        var cf7Email = newsletterModal.querySelector('input[name="your-email"]');
        if (cf7Email) { cf7Email.value = nlEmail; }
        var bsModal = bootstrap.Modal.getOrCreateInstance(newsletterModal);
        bsModal.show();
      }, 500);
    }
  }

  // Redirect to /info/ with email for sites without the CF7 form
  document.querySelectorAll('.ubp-newsletter-redirect').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var emailInput = this.closest('.ubp-newsletter-input-group').querySelector('.ubp-newsletter-input');
      var email = emailInput ? emailInput.value : '';
      var url = this.getAttribute('data-redirect-url');
      if (url) {
        window.location.href = url + '?newsletter=' + encodeURIComponent(email);
      }
    });
  });


  // ---------------------------------------------------------- MULTI LANGUAGE SWITCHER BUTTONS
  // ----------------------------------------------------------

  // clicco su tutto il pulsante — one-time click
  var mlpHandled = false;
  document.body.addEventListener('click', function(e) {
    var quicklink = e.target.closest('.mlp-quicklinks');
    if (quicklink && !mlpHandled) {
      e.preventDefault();
      mlpHandled = true;
      var innerLink = quicklink.querySelector('.mlp_inner a');
      if (innerLink) {
        innerLink.click();
      }
    }
  });


  // ---------------------------------------------------------- USABILITY
  // ----------------------------------------------------------

  // Imposto o acquisisco il valore in localStorage
  var ls_textZoom;
  if(localStorage.getItem('rwtextzoom') !== null){
    ls_textZoom = localStorage.getItem('rwtextzoom');
    zoomText(ls_textZoom);
  } else {
    ls_textZoom = '1';
  }

  // Setto il textZoom definito
  document.documentElement.style.fontSize = ls_textZoom + 'rem';

  // al click cambio textZoom (desktop #usability + mobile #usability-mobile)
  var usabilitySelector = '#usability span, #usability-mobile span';
  document.body.addEventListener('click', function(e) {
    var span = e.target.closest(usabilitySelector);
    if (span) {
      e.preventDefault();
      zoomText(span.dataset.size);
    }
  });

  // Funzione di cambio textZoom
  function zoomText(textSize){
    // gestione classi (sync desktop + mobile)
    document.querySelectorAll(usabilitySelector).forEach(function(s) {
      s.classList.remove('active');
    });
    document.querySelectorAll('#usability span[data-size="' + textSize + '"], #usability-mobile span[data-size="' + textSize + '"]').forEach(function(s) {
      s.classList.add('active');
    });

    // cambio fontSize e salvataggio valore in localStorage
    document.documentElement.style.fontSize = textSize + 'rem';
    localStorage.setItem('rwtextzoom', textSize);

    // Classe al body
    document.querySelectorAll(usabilitySelector).forEach(function(s) {
      if (s.id) {
        document.body.classList.remove(s.id);
      }
    });
    var selected = document.querySelector('#usability span[data-size="' + textSize + '"]');
    if (selected && selected.id) {
      document.body.classList.add(selected.id);
    }
  }

});
